/**
 * Events suite — module-id → view-component registry.
 *
 * Extending this map with more modules is a one-liner per module.
 * The router consults the map first; any module without an entry
 * falls through to the generic `<ModulePage/>` placeholder.
 */
import type { ComponentType } from 'react';
import type { Suite, ModuleSpec } from '../../data/types/platform';
import { FunnelView } from './funnel';
import { OrganizersView } from './organizers';
import { CoverageView } from './coverage';
import { FormatsView } from './formats';
import { ChannelsView } from './channels';
import { TrendsView } from './trends';
import { SpeakersView } from './speakers';

export interface SystemModuleViewProps {
  system: Suite;
  module: ModuleSpec;
}

export const EVENTS_MODULE_VIEWS: Record<string, ComponentType<SystemModuleViewProps>> = {
  funnel: FunnelView,
  organizers: OrganizersView,
  coverage: CoverageView,
  formats: FormatsView,
  channels: ChannelsView,
  trends: TrendsView,
  speakers: SpeakersView,
};
